export default __webpack_public_path__ + "static/card_side_button_2-7c0a12da7744ed385a4099012f26acb7.png";